import { Injectable } from "@angular/core";
import { QuoteFeatureState as Pillar3aQuoteFeatureState } from "src/app/shared/store/quote/pillar-3a/quote.state";
import { QuoteFeatureState as TermLifeInsuranceQuoteFeatureState } from "src/app/shared/store/quote/term-life-insurance/quote.state";

import { ApplicationFeatureState } from "../../../store/application/application.state";
import { NotificationMessagePayload } from "../../../store/notification/notification.actions";
import { NotificationMessage } from "../../../store/notification/notification.state";

import { NotificationCoreService } from "../core/notification-core.service";
import { CreateApplicationFailedNotificationService } from "./notifications/create-application-failed-notification.service";

@Injectable({
  providedIn: "root",
})
export class NotificationApplicationService {
  constructor(
    private readonly _createApplicationFailedNotificationService: CreateApplicationFailedNotificationService,
  ) {}

  createNotificationPayloads(
    previousApplicationFeatureState: ApplicationFeatureState,
    currentApplicationFeatureState: ApplicationFeatureState,
    currentTermLifeInsuranceQuoteFeatureState: TermLifeInsuranceQuoteFeatureState,
    _currentPillar3aQuoteFeatureState: Pillar3aQuoteFeatureState,
    _: NotificationMessage[] | undefined,
  ) {
    const notificationMessagePayloads: NotificationMessagePayload[] = [];

    const httpNotificationMessage =
      NotificationCoreService.tryCreateHttpNotificationMessage(
        previousApplicationFeatureState,
        currentApplicationFeatureState,
      );

    const hasUnderwritingQuestionsBeenResetNotificationMessage =
      this._createApplicationFailedNotificationService.tryCreateMissingUnderwritingQuestionNotificationMessage(
        currentApplicationFeatureState,
        currentTermLifeInsuranceQuoteFeatureState,
      );

    if (httpNotificationMessage) {
      notificationMessagePayloads.push(httpNotificationMessage);
    }

    if (hasUnderwritingQuestionsBeenResetNotificationMessage) {
      notificationMessagePayloads.push(
        hasUnderwritingQuestionsBeenResetNotificationMessage,
      );
    }

    return notificationMessagePayloads.length > 0
      ? notificationMessagePayloads
      : undefined;
  }
}
